/**
 * Shared utilities for the `facetKey:value` compound ID format
 * used by ResourcePicker and ResourceFieldConfigurator filter state.
 */

/** Parse compound IDs (e.g. `["type:Crane","type:Drill"]`) into a Map. */
export function fromCompoundIds(
  compoundIds: string[],
): Map<string, Set<string>> {
  const map = new Map<string, Set<string>>()
  for (const id of compoundIds) {
    const colonIdx = id.indexOf(':')
    if (colonIdx === -1) continue
    const facetKey = id.slice(0, colonIdx)
    const value = id.slice(colonIdx + 1)
    let facetSet = map.get(facetKey)
    if (!facetSet) {
      facetSet = new Set()
      map.set(facetKey, facetSet)
    }
    facetSet.add(value)
  }
  return map
}

/** Serialize a filter selection Map into compound IDs. */
export function toCompoundIds(selection: Map<string, Set<string>>): string[] {
  const ids: string[] = []
  for (const [facetKey, values] of selection) {
    for (const value of values) {
      ids.push(`${facetKey}:${value}`)
    }
  }
  return ids
}

/** Group compound IDs into `{ type, values }[]` for GraphQL input. */
export function toFilterOptions(
  compoundIds: string[],
): { type: string; values: string[] }[] {
  const groups: Record<string, string[]> = {}
  for (const id of compoundIds) {
    const colonIdx = id.indexOf(':')
    if (colonIdx === -1) continue
    const type = id.slice(0, colonIdx)
    const value = id.slice(colonIdx + 1)
    if (!groups[type]) groups[type] = []
    groups[type].push(value)
  }
  return Object.entries(groups).map(([type, values]) => ({ type, values }))
}
